import { ApiBase } from "@/api/ApiBase";

export interface ArtigoStockGeral {
  id: number;
  stock_min: number;
  stock_max: number;
  tipo: string;
  nome: string;
  codigo: string;
  preco: number;
  precoCompra: number;
  foto: string | null;
  qtdStock: number;
}

export interface ArtigoStockMov {
  id: number;
  nome: string;
  codigo: string;
  preco: number;
  precoCompra: number;
  qtdStock: number;
  nomeCodigo: string;
}

export interface MovimentoStock {
  tipo: "Entrada" | "Saida";
  motivo: string;
  qtd: number;
  dataCriacao: string;
  preco: number;
  foto: string | null;
  nome: string;
  codigo: string;
  nomeUtilizador: string;
}

export interface LinhaMovimentoPayload {
  produto: { id: number };
  qtd: number;
  precoCusto: number;
  motivo: string;
}

export interface RegistarMovimentoPayload {
  idEstabelecimento: number;
  accao: "Entrada" | "Saída";
  artigos: LinhaMovimentoPayload[];
}

export interface RegistarMovimentoResponse {
  code: number;
  msg: string;
  status: "Sucesso" | "Falha";
  data: unknown;
}

export class StockApi extends ApiBase {
  listarStockGeral(
    idEstabelecimento: number,
    pagina: number,
  ): Promise<ArtigoStockGeral[]> {
    return this.http.put<ArtigoStockGeral[]>(
      `/api/facturacao/artigo/lista-mercadorias-stock/list-stock/${idEstabelecimento}/${pagina}`,
    );
  }

  listarArtigosParaMovimento(
    idEstabelecimento: number,
    pagina: number,
  ): Promise<ArtigoStockMov[]> {
    return this.http.put<ArtigoStockMov[]>(
      `/api/facturacao/artigo/lista-mercadorias-stock/mov-stock/${idEstabelecimento}/${pagina}`,
    );
  }

  listarMovimentos(
    idEstabelecimento: number,
    pagina: number,
  ): Promise<MovimentoStock[]> {
    return this.http.put<MovimentoStock[]>(
      `/api-stock/lista-movimentos-stock/${idEstabelecimento}/${pagina}`,
    );
  }

  registarMovimento(
    payload: RegistarMovimentoPayload,
  ): Promise<RegistarMovimentoResponse> {
    const fd = new FormData();
    fd.append(
      "infoDoc",
      new Blob([JSON.stringify(payload)], { type: "application/json" }),
    );
    return this.http.postMultipart<RegistarMovimentoResponse>(
      "/api-stock/add",
      fd,
    );
  }
}
